module.exports = {
	"_args": [
		[
			"aws-appsync@1.3.4",
			"/root/project"
		]
	],
	"_from": "aws-appsync@1.3.4",
	"_id": "aws-appsync@1.3.4",
	"_inBundle": false,
	"_integrity": "sha512-5tmCKLRlvUYWnjAIoEMMbQvATZJXXpzTmGZgFS4MoqmvpdIVVqh+oJb0t+JGs/JX7iXnm+FQVilEoDavpZ2ayQ==",
	"_location": "/aws-appsync",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "aws-appsync@1.3.4",
		"name": "aws-appsync",
		"escapedName": "aws-appsync",
		"rawSpec": "1.3.4",
		"saveSpec": null,
		"fetchSpec": "1.3.4"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/aws-appsync/-/aws-appsync-1.3.4.tgz",
	"_spec": "1.3.4",
	"_where": "/root/project",
	"author": {
		"name": "Amazon Web Services",
		"url": "https://aws.amazon.com/"
	},
	"bugs": {
		"url": "https://github.com/awslabs/aws-mobile-appsync-sdk-js/issues"
	},
	"dependencies": {
		"@redux-offline/redux-offline": "^2.2.1",
		"apollo-cache-inmemory": "^1.0.0",
		"apollo-client": "2.3.7",
		"apollo-link": "^1.0.0",
		"apollo-link-context": "^1.0.0",
		"apollo-link-http": "^1.0.0",
		"aws-sdk": "^2.139.0",
		"graphql": "^0.11.7",
		"redux": "^3.7.2",
		"redux-thunk": "^2.2.0",
		"setimmediate": "^1.0.5",
		"url": "^0.11.0",
		"uuid": "3.x"
	},
	"description": "AWS Mobile AppSync SDK for JavaScript",
	"devDependencies": {
		"@types/graphql": "0.12.4",
		"@types/jest": "^23.3.1",
		"@types/node": "^8.0.46",
		"@types/zen-observable": "^0.5.3",
		"graphql-tag": "^2.9.2",
		"jest": "^23.4.2",
		"ts-jest": "^23.0.1",
		"typescript": "^3.0.1"
	},
	"homepage": "https://github.com/awslabs/aws-mobile-appsync-sdk-js.git",
	"jest": {
		"transform": {
			"^.+\\.tsx?$": "ts-jest"
		},
		"testRegex": "(/__tests__/.*|(\\.|/)(test|spec))\\.(jsx?|tsx?)$",
		"moduleFileExtensions": [
			"ts",
			"tsx",
			"js",
			"jsx",
			"json",
			"node"
		],
		"testEnvironment": "node"
	},
	"license": "SEE LICENSE IN LICENSE",
	"main": "lib/index.js",
	"name": "aws-appsync",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/awslabs/aws-mobile-appsync-sdk-js.git"
	},
	"scripts": {
		"prepare": "tsc && cp -r src/vendor lib/vendor",
		"test": "jest --coverage --coverageReporters=text",
		"test-watch": "jest --watch"
	},
	"version": "1.3.4"
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-appsync/package.json
// module id = 437
// module chunks = 1